import { render, staticRenderFns } from "./LotdSpellsComponent.vue?vue&type=template&id=b8b5ffd6&scoped=true"
import script from "./LotdSpellsComponent.vue?vue&type=script&lang=ts"
export * from "./LotdSpellsComponent.vue?vue&type=script&lang=ts"
import style0 from "./LotdSpellsComponent.vue?vue&type=style&index=0&id=b8b5ffd6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8b5ffd6",
  null
  
)

export default component.exports